import React from "react";
import "./styles.css";

const FloatingLabelTextInput = ({ id, label, type = "text", value, onChange, placeholder = "", required = false, disabled = false, className="" }) => {
  return (
    <div className={`input-container ${className}`}>
      <input type={type} id={id} value={value} onChange={onChange} className="text-input" placeholder={placeholder} required disabled={disabled}/>
      <label className="label" htmlFor={id}>{label}{required && <span className="req">*</span>}</label>
    </div>
  );
};

export default FloatingLabelTextInput;